import { render, staticRenderFns } from "./appReceiptData.vue?vue&type=template&id=0aa134de"
import script from "./appReceiptData.vue?vue&type=script&lang=js"
export * from "./appReceiptData.vue?vue&type=script&lang=js"
import style0 from "./appReceiptData.vue?vue&type=style&index=0&id=0aa134de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports